import { DataContext } from 'hooks/HeaderContext';
import React, { useContext } from 'react'
import { FILTER_KEY, FILTER_TYPE } from 'types/Dog';
import DogFilter from './DogFilter'
import MissouriMap from './MissouriMap';
import { Option } from 'types/Option';
import { toast } from 'react-toastify';


const FilterPanel: React.FC = () => {

    const {
        validFilters,
        selectedFilters,
        selectFilters,
        customView
    } = useContext(DataContext);

    const handleSelect = async (filters: Option[], type: string) => {
        // check if user is filtering institution. If so, and customView is used, then show confirmation dialog to let user know the customView will be cleared
        if (type === FILTER_KEY[FILTER_TYPE.INSTITUTION] && customView) {
            toast.info(
                <>
                    <h5 className='mb-2'>Institution changed</h5>
                    Your search radius has been reset.
                </>
            );
        }
        selectFilters(filters, type);
    }

    const buildBasicFilter = (type: FILTER_TYPE, index) => (
        <div className="w-100 mb-4" key={index}>
            <DogFilter
                title={type[0].toUpperCase() + type.slice(1).toLowerCase()}
                selectedFilters={selectedFilters[type] || []}
                onChange={filters => handleSelect(filters, type)}
                filterOptions={(validFilters && validFilters[type]) || []}
                formatLabel={type == FILTER_TYPE.AGE ? o => o.label.slice(0, o.label.indexOf('(') - 1) : undefined}
                isMobile={['size', 'age', 'gender'].includes(type)}
            />
        </div>
    )

    return (
        <div className="w-100" style={{ marginBottom: '80px' }}>
            {
                ['breed', 'size', 'age', 'gender', 'color'].map(buildBasicFilter)
            }
            <div className="mb-3">
                <div className="text-center h6 text-dark fw-bold">Location</div>
                <MissouriMap />
            </div>
            {
                ['institution', 'shelter'].map(buildBasicFilter)
            }
        </div>
    )
}

export default FilterPanel